(() => {
  'use strict';
  if (window.mxProgressGallery) { window.mxProgressGallery(); return; }
  const instances = new Map();
  function mount(root) {
    if (instances.has(root)) return;
    const track = root.querySelector('.mxpg-track');
    const photos = [...track.querySelectorAll('.mxpg-photo')];
    const controls = root.querySelector('.mxpg-controls');
    const pages = root.querySelector('.mxpg-pages');
    const count = root.querySelector('.mxpg-count');
    const previous = root.querySelector('[data-photo-previous]');
    const next = root.querySelector('[data-photo-next]');
    const mobile = matchMedia('(max-width:767px)');
    const reduced = matchMedia('(prefers-reduced-motion:reduce)');
    const events = new AbortController();
    const options = { signal: events.signal };
    let stops = [], active = 0, perPage = 1, frame = 0;
    function update() {
      frame = 0;
      active = stops.reduce((best, stop, i) => Math.abs(stop - track.scrollLeft) < Math.abs(stops[best] - track.scrollLeft) ? i : best, 0);
      const first = Math.min(photos.length - perPage, active * perPage) + 1;
      const last = Math.min(photos.length, first + perPage - 1);
      count.textContent = `${first === last ? first : `${first}–${last}`} / ${photos.length}`;
      previous.disabled = active === 0;
      next.disabled = active === stops.length - 1;
      [...pages.children].forEach((button, i) => button.setAttribute('aria-current', String(i === active)));
    }
    function go(index, immediate = false) {
      const target = Math.max(0, Math.min(stops.length - 1, index));
      track.scrollTo({ left: stops[target], behavior: immediate || reduced.matches ? 'instant' : 'smooth' });
    }
    function layout() {
      const first = active * perPage;
      perPage = Math.min(photos.length, mobile.matches ? 1 : 2);
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      stops = photos.filter((_, i) => i % perPage === 0).map(photo => Math.min(max, photo.offsetLeft - photos[0].offsetLeft));
      pages.replaceChildren(...stops.map((_, i) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', `Show photo${perPage > 1 ? 's' : ''} ${i * perPage + 1}${perPage > 1 ? `–${Math.min(photos.length, (i + 1) * perPage)}` : ''}`);
        button.setAttribute('aria-controls', track.id);
        button.addEventListener('click', () => go(i));
        return button;
      }));
      controls.hidden = stops.length < 2;
      go(Math.floor(first / perPage), true);
      update();
    }
    previous.addEventListener('click', () => go(active - 1), options);
    next.addEventListener('click', () => go(active + 1), options);
    track.addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(update); }, { ...options, passive: true });
    track.addEventListener('keydown', event => {
      if (event.target !== track) return;
      const targets = { ArrowRight: active + 1, ArrowLeft: active - 1, Home: 0, End: stops.length - 1 };
      if (!(event.key in targets)) return;
      event.preventDefault(); go(targets[event.key]);
    }, options);
    document.addEventListener('shopify:block:select', event => {
      const index = photos.findIndex(photo => photo.dataset.photoBlock === event.detail?.blockId);
      if (index >= 0 && (!event.detail.sectionId || event.detail.sectionId === root.closest('[data-mx-position-section]')?.dataset.mxPositionSection)) go(Math.floor(index / perPage), true);
    }, options);
    const observer = new ResizeObserver(layout);
    observer.observe(track);
    mobile.addEventListener('change', layout, options);
    instances.set(root, () => { events.abort(); observer.disconnect(); cancelAnimationFrame(frame); });
    layout();
  }
  window.mxProgressGallery = () => document.querySelectorAll('[data-progress-gallery]').forEach(mount);
  document.addEventListener('shopify:section:load', window.mxProgressGallery);
  document.addEventListener('shopify:section:unload', event => instances.forEach((cleanup, root) => {
    if (event.target.contains(root)) { cleanup(); instances.delete(root); }
  }));
  window.mxProgressGallery();
})();
